<template>
    <a-select
        mode="multiple"
        v-model:value="valueState"
        style="width: 300px"
        placeholder="Pilih Group Role"
        allow-clear
        show-search
        :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @dropdownVisibleChange="() => (state.params.q = '')"
        v-bind="$attrs"
        :loading="state.loading"
        :show-arrow="true">
        <a-select-option v-for="item in state.data" :key="item.id" :label="item.name">
            <span v-html="highlight(item.name)"></span>
        </a-select-option>
        <template v-if="state.loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </a-select>
</template>

<script>
import { onMounted, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, toString } from 'lodash'

export default {
    props: {
        value: {
            default: () => [],
            type: Array,
        },
        role: {
            default: () => [],
            type: [String, Number, Array],
        },
        displayLabel: {
            type: String,
            default: null,
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: '/api/filter/group-role',
            loading: false,
            data: [],
            params: {
                q: '',
                role: props.role,
            },
        })

        const fetchLists = () => {
            state.loading = true
            apiClient
                .get(state.endpoint, { params: state.params })
                .then(({ data }) => {
                    state.data = data.sort((a, b) =>
                        toString(a.name).toLowerCase() > toString(b.name).toLowerCase() ? 1 : -1,
                    )
                })
                .finally(() => {
                    state.loading = false
                })
        }

        const onSearch = (value) => {
            state.params.q = value
        }

        const highlight = value => {
            return toString(value).replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        onMounted(() => {
            fetchLists()

            state.data.push({ name: props.displayLabel, id: props.value })
        })

        watch(() => props.role, () => {
            state.params.role = props.role
        })

        watch(state.params, debounce(() => {
            fetchLists()
        }, 300))

        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
        }
    },
}
</script>
